import React, { PropsWithChildren, useContext, useState } from 'react';
import { CustomText } from '@/components/CustomText';
import { ScrollView, ScrollViewProps, StyleProp, StyleSheet, TextProps, TextStyle, useWindowDimensions, View, ViewStyle } from 'react-native';
import { Text } from 'react95-native-rabbl';
import { CustomDivider } from "@/components/CustomDivider";
import { Link } from 'expo-router';
import * as AppConsts from '@/utilities/AppConsts';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import { BasicScrollView } from "@/components/BasicScrollView";
import { AppText } from "@/components/AppText";

const styles = StyleSheet.create({
});

interface WidthResponsiveTextProps extends TextProps {
  leftPadding?: number,
  rightPadding?: number,
  style?: StyleProp<TextStyle>,
};

export function WidthResponsiveText({
  children,
  leftPadding = AppConsts.TITLE_TEXT_PADDING_LEFT,
  rightPadding = AppConsts.TITLE_TEXT_PADDING_RIGHT,
  style,
  ...props
}: PropsWithChildren<WidthResponsiveTextProps>) : React.ReactNode {
  const { width } = useWindowDimensions();
  
  return (
    <AppText
      ellipsizeMode="tail"
      numberOfLines={1}
      style={[style, { width: width - leftPadding - rightPadding }]}
      {...props}
    >
      {children}
    </AppText>
  );
};
